<template>
  <v-app style="-webkit-app-region: drag">
    <v-content>
      <v-container class="scroll-y" fluid>
        <v-layout row align-center justify-center>
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-content>
    <loader v-model="dialogLoader"/>
  </v-app>
</template>

<script>

import Loader from '@/components/UI/Loader.vue';
import {logout} from '@/mixins/logout';

export default {
  name: 'LayoutAdmin',
  components: {
    Loader,
  },
  mixins: [logout],
  data: () => ({
    fab: false,
    mini: true,
    user: {},
    dialogLoader: false,
  }),
  computed: {
    loading() {
      return this.$store.getters.loading
    }
  },
  watch: {
    loading() {
      this.dialogLoader = this.loading;
    }
  }
}
</script>
